var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.387,
    height: 27.209,
    viewBox: "0 0 5.387 27.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(-1732.161 -535.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M29.965,45.126A2.6,2.6,0,0,1,28.1,45.9a2.657,2.657,0,0,1-1.885-.768,2.884,2.884,0,0,1-.822-2.175,3,3,0,0,1,.775-2.073,2.484,2.484,0,0,1,1.9-.855,2.538,2.538,0,0,1,1.915.851,2.968,2.968,0,0,1,.8,2.076A2.9,2.9,0,0,1,29.965,45.126Z",
    transform: "translate(1706.767 517.019)",
    fill: "#c90c0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M30.667,22.711l-.687,8.654a7.6,7.6,0,0,1-.507,2.482,1.534,1.534,0,0,1-1.467,1,1.489,1.489,0,0,1-1.453-.979,8.88,8.88,0,0,1-.5-2.533l-.514-8.423c-.1-1.663-.141-2.826-.141-3.55a3.735,3.735,0,0,1,.77-2.486A2.553,2.553,0,0,1,28.2,15.96a2.077,2.077,0,0,1,2.091,1.219,7.952,7.952,0,0,1,.493,3.15C30.781,21.1,30.741,21.905,30.667,22.711Z",
    transform: "translate(1706.767 519.752)",
    fill: "#c90c0f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPickup);
export default __webpack_public_path__ + "static/media/alertPickup.6d9d56f85e50a5a69e7f1a55bdbffabe.svg";
export { ForwardRef as ReactComponent };